
import {createSlice} from "@reduxjs/toolkit";

export const exchangeSlice = createSlice({
    name: 'exchangeSlc',
    initialState: {value: {id: null, externalId: null, rateDate: null,
            currencyFrom: null, currencyTo: null, rate: null, source: null,
            effective_date: null, expired_on: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            exchangeDrawerState: false, exchangeDrawerMode: null, exchangeGridRefresh: false,
            exchangeUploadState: false
        }},
    reducers:

        {
            changeExchange: (state, action) => {
                state.value = {
                    ...state.value,  // Keep existing fields
                    ...action.payload // Merge new values
                };
            }
        }
});

export const { changeExchange } = exchangeSlice.actions;

export default  exchangeSlice.reducer ;

